export class Aeroespecialidad{
    id: string;
    codigoAeroespecialidad: string;
    nombreAeroespecialidad: string;
    stock: number;
}